













































import Vue from 'vue';

export default Vue.extend({
  name: 'ReviewCardItem',

  props: {
    id: {
      type: Number,
      default: 0,
    },

    name: {
      type: String,
      required: true,
    },

    showId: {
      type: Number,
      default: 0,
    },

    showName: {
      type: String,
      required: true,
    },

    image: {
      type: String,
      required: true,
    },

    padding: {
      type: Boolean,
      default: false,
    },

    rating: {
      type: Number,
      default: 0,
    },

    description: {
      type: String,
      required: true,
    },
  },

  methods: {
    goToShow() {
      this.$router.push(`/show/${this.showId}`);
    },
  },
});
